import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection, scrollToTop } from "../../lib/scroll";

const links = [
  { label: "Services", id: "services" },
  { label: "Resources", id: "resources" },
  { label: "About", id: "about" },
  { label: "Research Rigour", id: "rigour" },
  { label: "Book", id: "book" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-black/60 backdrop-blur-xl border-white/10" : "bg-black/30 backdrop-blur-md border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <button type="button" onClick={() => { setOpen(false); scrollToTop(); }} data-testid="header-logo" className="flex items-center gap-3 shrink-0">
          <img src="/bigibila-logo.png" alt="Bigibila Research" className="h-10 w-10" />
          <span className="font-serif text-xl tracking-tight text-bone">Bigibila</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-ochre hidden xl:inline">Research</span>
        </button>
        <nav className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <button
              key={l.id}
              type="button"
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}`}
              className="link-underline font-mono text-[11px] uppercase tracking-[0.15em] text-stone2 hover:text-bone transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => go("briefing")}
            data-testid="header-engage-btn"
            className="font-mono text-xs uppercase tracking-[0.15em] px-5 py-2.5 bg-ember text-ink hover:bg-emberDeep transition-colors duration-300 whitespace-nowrap hidden sm:inline-block"
          >
            Request a Confidential Briefing
          </button>
          <button
            type="button"
            data-testid="mobile-menu-btn"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="lg:hidden text-bone hover:text-ember transition-colors duration-300 p-2"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                type="button"
                onClick={() => go(l.id)}
                data-testid={`mobile-nav-${l.id}`}
                className="text-left font-mono text-xs uppercase tracking-[0.2em] py-3 border-b border-white/5 text-stone2 hover:text-bone transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => go("briefing")}
              data-testid="mobile-briefing-btn"
              className="font-mono text-xs uppercase tracking-[0.2em] text-center px-5 py-3.5 mt-3 bg-ember text-ink hover:bg-emberDeep transition-colors duration-300"
            >
              Request a Confidential Briefing
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
